var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.768,
    height: 31.178,
    viewBox: "0 0 46.768 31.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M46.485,18.9a26.042,26.042,0,0,0-23.1-14.4A26.046,26.046,0,0,0,.283,18.9a2.627,2.627,0,0,0,0,2.37,26.042,26.042,0,0,0,23.1,14.4,26.046,26.046,0,0,0,23.1-14.4A2.627,2.627,0,0,0,46.485,18.9Zm-23.1,12.877A11.692,11.692,0,1,1,35.076,20.089,11.692,11.692,0,0,1,23.384,31.781Zm0-19.486a7.739,7.739,0,0,0-2.055.308A3.885,3.885,0,0,1,15.9,18.034a7.777,7.777,0,1,0,7.487-5.74Z",
    transform: "translate(0 -4.5)",
    fill: "#4188f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowDetail);
export default __webpack_public_path__ + "static/media/show-detail.cde9ff0bb2414dbfbe94a6366dee41a1.svg";
export { ForwardRef as ReactComponent };